/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Button,
  Card,
  Typography,
  Space,
  message,
  Breadcrumb,
} from "antd";
import axios from "axios";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  SendOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

import { Link } from "react-router-dom";
import styles from "./index.module.scss";
import { apiUrl } from "../../../../Constant";

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

function Contact() {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onFinish = async (values) => {
    try {
      setSubmitting(true);
      const res = await axios.post(apiUrl.ADD_CONTACT_US, values);
      if (res?.data?.type === "success") {
        message.success("Thank you! Your message has been sent.");
        form.resetFields();
      } else {
        message.error(res?.data?.message || "Failed to send message.");
      }
    } catch (error) {
      message.error("Failed to send message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const ContactInfo = ({ icon, title, content }) => (
    <div className={styles.infoItem}>
      <div className={styles.iconWrapper}>{icon}</div>
      <div>
        <Text className={styles.infoTitle}>{title}</Text>
        <Paragraph className={styles.infoContent}>{content}</Paragraph>
      </div>
    </div>
  );

  return (
    <div className={styles.contactContainer}>
      {/* Breadcrumb */}
      <div className={styles.breadcrumbBar}>
        <div className={styles.breadcrumbInner}>
          <Breadcrumb
            className={styles.breadcrumb}
            items={[
              { title: <Link to="/">Home</Link> },
              { title: "Contact Us" },
            ]}
          />
        </div>
      </div>

      <div className={styles.headerSection}>
        <span className={styles.eyebrow}>The Diamond Counter</span>
        <Title level={1}>Contact Us</Title>
        <div className={styles.headingLine} />
        <Paragraph className={styles.subTitle}>
          Have questions? We'd love to hear from you. Send us a message and
          we'll respond as soon as possible.
        </Paragraph>
      </div>

      <Row justify="center">
        <Col xs={22} xl={20}>
          <Row gutter={[48, 48]} className={styles.contentRow}>
            {/* Left Column: Contact Details */}
            <Col xs={24} lg={10} className={styles.contactInfoCol}>
              <div className={styles.infoCard}>
                <h3 className={styles.sectionTitle}>Contact Information</h3>
                <Space
                  direction="vertical"
                  size={32}
                  style={{ width: "100%", marginTop: "40px" }}
                >
                  <ContactInfo
                    icon={<PhoneOutlined />}
                    title="Call"
                    content={
                      <a href="tel:+441617061696" className={styles.contactLink}>
                        +44 (0) 0161 706 1696
                      </a>
                    }
                  />
                  <ContactInfo
                    icon={<WhatsAppOutlined />}
                    title="WhatsApp"
                    content={
                      <a
                        href="https://wa.me/447793219535"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.contactLink}
                      >
                        +44 (0) 779 321 9535
                      </a>
                    }
                  />
                  <ContactInfo
                    icon={<MailOutlined />}
                    title="E-Mail"
                    content={
                      <a href="mailto:sales@thediamondcounter.com" className={styles.contactLink}>
                        sales@thediamondcounter.com
                      </a>
                    }
                  />
                  <ContactInfo
                    icon={<EnvironmentOutlined />}
                    title="Address"
                    /* Adnan gave these four lines verbatim on 2026-09-02, to match
                       Xclusive's contact page. The company name leads it: Gemex
                       Trading Ltd is the contracting party behind both trading
                       names. "Aviator" is spelled as it already is here and on the
                       factory invoice template — his note read "Avaitor". */
                    content={
                      <span>
                        Gemex Trading Ltd
                        <br />
                        Regus, Aviator Way
                        <br />
                        Manchester
                        <br />
                        M22 5TG
                      </span>
                    }
                  />
                  <ContactInfo
                    icon={<ClockCircleOutlined />}
                    title="Opening Hours"
                    content={
                      <span>
                        MON to FRI: 9:00AM - 6:00PM
                        <br />
                        SAT to SUN: CLOSED
                      </span>
                    }
                  />
                </Space>
              </div>
            </Col>

            {/* Right Column: Contact Form */}
            <Col xs={24} lg={14} className={styles.messageCol}>
              <h3 className={styles.sectionTitle}>Message Us</h3>
              <Card className={styles.formCard} bordered={false}>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  size="large"
                >
                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Full Name"
                        name="name"
                        rules={[
                          { required: true, message: "Please enter your name" },
                        ]}
                      >
                        <Input placeholder="John Doe" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your email",
                          },
                          {
                            type: "email",
                            message: "Please enter a valid email",
                          },
                        ]}
                      >
                        <Input placeholder="john@example.com" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    label="Subject"
                    name="subject"
                    rules={[
                      { required: true, message: "Please enter a subject" },
                    ]}
                  >
                    <Input placeholder="How can we help?" />
                  </Form.Item>

                  <Form.Item
                    label="Message"
                    name="message"
                    rules={[
                      { required: true, message: "Please enter your message" },
                    ]}
                  >
                    <TextArea
                      rows={5}
                      placeholder="Type your message here..."
                      style={{
                        height:100
                      }}
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<SendOutlined />}
                      className={styles.submitBtn}
                      block
                      loading={submitting}
                    >
                      Send Message
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>

          <div className={styles.mapSection}>
            <div className={styles.mapHeading}>
              <span className={styles.eyebrow}>Find Us</span>
              <Title level={3} className={styles.mapTitle}>Our Location</Title>
              <div className={styles.headingLine} />
            </div>
            <div className={styles.mapFrame}>
              <iframe
                title="The Diamond Counter Location"
                className={styles.mapIframe}
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d76181.14598838796!2d-2.2649!3d53.367225000000005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487a5336702d4ce3%3A0x7fd9deafd853230!2sXclusive%20Diamonds!5e0!3m2!1sen!2sus!4v1773187016176!5m2!1sen!2sus"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Contact;
